import { render, staticRenderFns } from "./EdmPreviewButton.vue?vue&type=template&id=630a55e5&"
import script from "./EdmPreviewButton.vue?vue&type=script&lang=js&"
export * from "./EdmPreviewButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports